/** Versão exposta no build via `next.config.mjs` (`NEXT_PUBLIC_APP_VERSION`). */
export const APP_VERSION = process.env.NEXT_PUBLIC_APP_VERSION?.trim() || '0.1.2';
